import type { TTagOption } from '../../../packages/Tags/shared/types/tag';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IDirection } from 'shared/types/geo';
import { ITags } from 'shared/types/tags';
import { IGeoTags } from 'shared/types/tags/geoTags';

export const initialState: ITags = {
  items: [],
  meta: {
    geoTags: {} as IGeoTags,
    directions: [],
    undergroundsUnderConstruction: {},
    village: null,
    needUpdateGeoTags: false,
  },
};

export const tagsSlice = createSlice({
  name: 'tags',
  initialState,
  reducers: {
    removeAllTags: state => {
      state.items = [];
    },
    setTags: (state, action: PayloadAction<TTagOption[]>) => {
      state.items = action.payload;
    },
    setGeoTags: (state, action: PayloadAction<IGeoTags>) => {
      state.meta.geoTags = action.payload;
    },
    setDirections: (state, action: PayloadAction<IDirection[]>) => {
      state.meta.directions = action.payload;
    },
    setNeedUpdateGeoTags: (state, action: PayloadAction<boolean>) => {
      state.meta.needUpdateGeoTags = action.payload;
    },
  },
});

export const {
  name: tagsReducerName,
  reducer: tagsReducer,
  actions: { removeAllTags, setTags, setGeoTags, setDirections, setNeedUpdateGeoTags },
} = tagsSlice;
